// исключены буквы, которые могут быть спутаны с другими буквами или цифрами
const codeAlphabet = "0123456789ACDEFGHKLMNPRSTUXYZ";
const codeLength = 8;

export const generateCode = () =>
	Array.from({ length: codeLength })
		.map(() => codeAlphabet[Math.floor(Math.random() * codeAlphabet.length)])
		.join("");
